import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export const useReplenishmentPhaseoutMethods = () => {
    return useApiQuery('/api/metadata/replenishmentphaseoutmethods', 'get');
};
